import {userConstants} from '../../_constants';

export function catalogPage(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_PAGE_PRODUCT_GROUP_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_PAGE_PRODUCT_GROUP_SUCCESS:
      return {
        ...action.data,
      };
    case userConstants.GET_PAGE_PRODUCT_GROUP_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
